<st-pages-container
  [navigationList]="navigationList"
  [configurations]="configurations"
  [tools]="[]"
  [regions]="[]"
  [locations]="[]"
>
  <div ngProjectAs="notification-section-template">
    <div class="notification-section-template-sample flex align-items-center">
      <button>
        <em class="icon-chats-circle-solid"></em>
      </button>
      <button>
        <em class="icon-bell"></em>
      </button>
    </div>
  </div>
  <div
    ngProjectAs="page-content"
    class="h-full overflow-scroll main-router-outlet"
    [ngClass]="{'p-spacing-2xl': !isDispatchRoute && !isDashboardRoute}"
  >
    <router-outlet></router-outlet>
  </div>
</st-pages-container>
